module Eseebase {
    export class ConfigurationModel {
    }
}